import { ComponentProps, FC } from "react";
import { GlobalStateProvider } from "../Context";
import { CustomerRepositoryProvider } from "../store/Customer";
import { DistributorRepositoryProvider } from "../store/Distributors";
import { MeRepositoryProvider } from "../store/Me";
import { UserRepositoryProvider } from "../store/Users";

export const combineComponents = (...components: FC[]): FC => {
  return components.reduce(
    (AccumulatedComponents, CurrentComponent) => {
      return ({ children }: ComponentProps<FC>): JSX.Element => {
        return (
          <AccumulatedComponents>
            <CurrentComponent>{children}</CurrentComponent>
          </AccumulatedComponents>
        );
      };
    },
    ({ children }) => <>{children}</>
  );
};

const providers = [
  GlobalStateProvider,
  MeRepositoryProvider,
  UserRepositoryProvider,
  CustomerRepositoryProvider,
  DistributorRepositoryProvider,
];

export const AppContextProvider = combineComponents(...providers);
